















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class DialogVerifyCode extends Vue {
    @Prop({ type: String }) imgUrl!: string
    @Prop({ type: Boolean, default: false }) dialogShow!: boolean

    codeData = ''
    $refs!: { fakeInput: HTMLInputElement }

    // @Emit()
    // returnPicCode() {
    //     return
    // }
    inputFoucs() {
        this.$refs.fakeInput.focus()
    }
    refresh() {
        this.$emit('refreshPic')
    }
    onChange(inputData: any) {
        const data: string = inputData.target.value
        this.codeData = data.replace(/[^a-zA-Z0-9]/g, '')
        // console.log(data, 'dataa')
        if (data.length >= 4) {
            this.$emit('returnPicCode', data)
            this.codeData = ''
        }
    }
    closeDialog() {
        this.$emit('closeDialog')
    }
}
